module.exports = new __parcel__URL__("data-privacy.b24f52d9.svg").toString();